import styled from 'styled-components'
import { blue, black, textMuted, white, grey } from '@/theme/colors'
import { shadows, radii, motion } from '@/theme/tokens'
import { fontSizes } from '@/theme/typography'
import { Button } from '@components/Button'

export const Toolbar = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 16px;
	margin-bottom: 16px;
	flex-wrap: wrap;
`

export { SearchInput } from '../adminList.styles'
import { Pill } from '@components/Pill'

export const ResultCount = styled.span`
	font-size: ${fontSizes.small};
	color: ${textMuted};
	white-space: nowrap;
`

export const TableWrapper = styled.div`
	background-color: ${white};
	border-radius: ${radii.inner};
	box-shadow: ${shadows.inner};
	overflow-x: auto;
`

export const Table = styled.table`
	width: 100%;
	border-collapse: collapse;
	font-size: ${fontSizes.base};
`

export const Th = styled.th`
	text-align: left;
	padding: 14px 16px;
	font-weight: 700;
	color: ${textMuted};
	border-bottom: 1px solid ${grey};
	white-space: nowrap;
`

export const Td = styled.td`
	padding: 14px 16px;
	color: ${black};
	border-bottom: 1px solid ${grey};
	vertical-align: top;
`

export const Tr = styled.tr<{ $deleted?: boolean }>`
	cursor: pointer;
	opacity: ${({ $deleted }) => ($deleted ? 0.6 : 1)};
	transition: background-color ${motion.fast};

	&:hover {
		background-color: ${blue}0d;
	}

	&:last-child td {
		border-bottom: none;
	}
`

export const OwnerName = styled.div`
	font-weight: 500;
`

export const OwnerEmail = styled.div`
	font-size: ${fontSizes.caption};
	color: ${textMuted};
`

export const Muted = styled.span`
	color: ${textMuted};
`

export const DeletedBadge = styled(Pill).attrs({ $tone: 'danger' as const })`
	margin-left: 8px;
`

export const InternalBadge = styled(Pill).attrs({ $tone: 'cool' as const })`
	margin-left: 8px;
`

export const Pagination = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 16px;
	margin-top: 16px;
`

export const PageButton = styled(Button).attrs({ variant: 'secondary' as const, size: 'sm' as const })``

export const PageStatus = styled.span`
	font-size: ${fontSizes.small};
	color: ${textMuted};
`


